export default __webpack_public_path__ + "static/media/userIcon.55c11508.svg";